import React from "react";

import { CompensationCycleResponse } from "@performyard/service-contracts";

import CompleteCycleModal from "./CompleteCycleModal";
import DeleteCycleModal from "./DeleteCycleModal";
import EditCycleModal from "./EditCycleModal";
import ReopenCycleModal from "./ReopenCycleModal";

type ModalTypes = "edit" | "delete" | "complete" | "reopen";

type CycleDetailsModalProps = {
	cycleId: string;
	cycleModalOpen: ModalTypes;
	closeModal: () => void;
	cycleDetails: CompensationCycleResponse;
};

const CycleDetailsModal: React.FC<CycleDetailsModalProps> = ({ cycleId, cycleModalOpen, closeModal, cycleDetails }) => {
	if (cycleModalOpen === "delete") {
		return <DeleteCycleModal cycleId={cycleId} closeModal={closeModal} />;
	}

	if (cycleModalOpen === "complete") {
		return <CompleteCycleModal cycleId={cycleId} closeModal={closeModal} />;
	}

	if (cycleModalOpen === "edit") {
		return <EditCycleModal cycleId={cycleId} closeModal={closeModal} cycleDetails={cycleDetails} />;
	}

	if (cycleModalOpen === "reopen") {
		return <ReopenCycleModal cycleId={cycleId} closeModal={closeModal} />;
	}

	return null;
};

export default CycleDetailsModal;
